import { Injectable, signal } from '@angular/core';

import {
  DealerBranchOption,
  DealerWithBranches,
  isDealerBranchPairCoherent,
  selectableDealerBranches,
} from '../model/open-quote.model';

/**
 * Catálogo de distribuidores y sucursales compartido entre la cabecera
 * financiera (que lo carga) y la página de la cotización (que lo consulta
 * antes de guardar).
 *
 * Existe para que el guardado pueda verificar de forma SÍNCRONA que la
 * sucursal pertenezca al distribuidor, sin repetir el HTTP ni depender del
 * componente hijo.
 */
@Injectable({ providedIn: 'root' })
export class DealerBranchCatalogService {
  private readonly _dealers = signal<readonly DealerWithBranches[]>([]);
  readonly dealers = this._dealers.asReadonly();

  setDealers(dealers: readonly DealerWithBranches[] | null | undefined): void {
    this._dealers.set(dealers ?? []);
  }

  branchesOf(dealerId: number | string | null | undefined): DealerBranchOption[] {
    return selectableDealerBranches(this._dealers(), dealerId);
  }

  isPairCoherent(
    dealerId: number | string | null | undefined,
    branchId: number | string | null | undefined
  ): boolean {
    return isDealerBranchPairCoherent(this._dealers(), dealerId, branchId);
  }
}
